const KEY = "foretour:accessedCodes";
const COOKIE = "foretour_trip_codes";
const YEAR = 60 * 60 * 24 * 365;

function readCookieCodes(): string[] {
  const m = document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=([^;]*)`));
  if (!m) return [];
  return decodeURIComponent(m[1]).split(",").map(s => s.trim().toUpperCase()).filter(Boolean);
}

function writeCookieCodes(codes: string[]): void {
  const value = encodeURIComponent(codes.join(","));
  document.cookie = `${COOKIE}=${value}; Max-Age=${YEAR}; Path=/; SameSite=Lax; Secure`;
}

function readLocalCodes(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

function writeLocalCodes(codes: string[]): void {
  localStorage.setItem(KEY, JSON.stringify(codes));
}

export function getAccessedCodes(): string[] {
  const merged = Array.from(new Set([...readLocalCodes(), ...readCookieCodes()]));
  return merged.map(c => c.toUpperCase());
}

export function addAccessedCode(code: string): void {
  const upper = code.trim().toUpperCase();
  if (!upper) return;
  const merged = Array.from(new Set([...getAccessedCodes(), upper]));
  writeLocalCodes(merged);
  writeCookieCodes(merged);
}

export function removeAccessedCode(code: string): void {
  const upper = code.trim().toUpperCase();
  const merged = getAccessedCodes().filter(c => c !== upper);
  writeLocalCodes(merged);
  writeCookieCodes(merged);
}
